import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ds-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-field' },
  template: `
    <label class="ds-field__label" [attr.for]="forId()">
      {{ label() }}
      @if (optional()) {
        <span class="ds-field__optional">Optional</span>
      }
    </label>
    <ng-content />
    @if (error()) {
      <p class="ds-field__error" [id]="messageId()" role="alert">{{ error() }}</p>
    } @else if (hint()) {
      <p class="ds-field__hint" [id]="messageId()">{{ hint() }}</p>
    }
  `,
})
export class DsFieldComponent {
  readonly label = input.required<string>();
  readonly forId = input.required<string>();
  readonly hint = input('');
  readonly error = input('');
  readonly optional = input(false);
  readonly messageId = input('');
}
